/****************************************************
 * Module Name:  mixColorProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class MixColorProxy {
  static GetAllColor = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/color",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllColorMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/color/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleColor = (colorId, callback) => {
    let params = {
      id: colorId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/mix/color",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckColorAvailable = (color, callback) => {
    let params = {
      color: color,
    };

    restAPICall(
      Constants.MANAGER_URL + "/mix/color/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddColor = (color, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/color",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(color),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateColor = (color, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/color",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(color),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
